import React, { useEffect, useState } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

import AdinHome1 from "../assets/img/adinhome1.jpg";
import AdinHome2 from "../assets/img/adinhome2.jpg";
import AdinHome3 from "../assets/img/adinhome3.jpg";
// import Adins4 from '../assets/img/adins4.png';

const images = [
  // { src: Adins4, text: '' },
  { src: AdinHome3, text: "" },
  { src: AdinHome1, text: "" },
  { src: AdinHome2, text: "" },
];

const MainSection: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState<number>(0);

  // Move to the next slide every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000);

    // Clear interval on component unmount to avoid memory leaks
    return () => clearInterval(interval);
  }, []);

  const goToNextSlide = () => {
    setActiveIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const goToPrevSlide = () => {
    setActiveIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  return (
    <section className="relative min-h-fit w-full bg-gray-200">
      {/* Carousel Text */}
      <div className="absolute top-20 left-40 z-10 text-white text-4xl font-bold">
        {images[activeIndex].text}
      </div>

      {/* Carousel Images */}
      <div className="w-full h-min">
        <img
          src={images[activeIndex].src}
          alt={images[activeIndex].text}
          className="w-full h-full"
        />
      </div>

      {/* Pagination */}
      {/* <div className="absolute bottom-2 w-full flex justify-center space-x-2">
        {images.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setActiveIndex(idx)}
            className={`w-2 h-2 rounded-full ${
              idx === activeIndex ? 'bg-blue-600' : 'bg-gray-400'
            }`}
          />
        ))}
      </div> */}

      {/* Navigation Controls using Icons */}

      <button
        className="absolute left-5 top-1/2 transform -translate-y-1/2  text-white p-2 rounded-full hidden sm:block"
        onClick={goToPrevSlide}
      >
        <FaChevronLeft className="h-8 w-8" />
      </button>
      <button
        className="absolute right-5 top-1/2 transform -translate-y-1/2  text-white p-2 rounded-full hidden sm:block"
        onClick={goToNextSlide}
      >
        <FaChevronRight className="h-8 w-8" />
      </button>
    </section>
  );
};

export default MainSection;
